import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import './NotFound.css';

const NotFound = () => {
  const [gameExpanded, setGameExpanded] = useState(false);
  const iframeRef = useRef(null);
  const gameContainerRef = useRef(null);
  const contentRef = useRef(null);

  // Handle expand/collapse of the game
  const toggleGameExpansion = () => {
    setGameExpanded(!gameExpanded);
  };

  // Handle keyboard events
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Close expanded game with Escape key
      if (e.key === 'Escape' && gameExpanded) {
        setGameExpanded(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [gameExpanded]);

  // Handle clicks outside the iframe to collapse it when expanded
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        gameExpanded && 
        gameContainerRef.current && 
        !gameContainerRef.current.contains(e.target)
      ) {
        setGameExpanded(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [gameExpanded]);

  return (
    <div className={`not-found-container ${gameExpanded ? 'not-found-game-expanded' : ''}`}>
      <Navbar />
      
      <div className="not-found-content" ref={contentRef}>
        <div className="not-found-error-code">404</div>
        
        <div className="not-found-message-container">
          <p className="not-found-message">
            您访问的链接不存在或网站正在维护中，请24小时后重试。
          </p>
          
          <div className="not-found-pacman-invitation">
            <span className="not-found-play-invitation">玩一局吃豆人？</span>
            <button 
              className="not-found-expand-button"
              onClick={toggleGameExpansion}
              aria-label={gameExpanded ? "收起游戏" : "展开游戏"}
            >
              {gameExpanded ? '收起' : '展开'}
            </button>
          </div>
        </div>
        
        <div className="not-found-footer-links">
          <Link to="/" className="not-found-home-link">
            返回首页
          </Link>
        </div>
      </div>
      
      {/* Background decoration elements */}
      <div className="not-found-background-decoration">
        <div className="not-found-ghost not-found-ghost-1"></div>
        <div className="not-found-ghost not-found-ghost-2"></div>
        <div className="not-found-ghost not-found-ghost-3"></div>
        <div className="not-found-ghost not-found-ghost-4"></div>
        <div className="not-found-pacman-decoration"></div>
        <div className="not-found-dots-decoration"></div>
      </div>
      
      {/* Game container - kept separate from decorations */}
      {gameExpanded && (
        <div 
          className="not-found-game-container not-found-expanded"
          ref={gameContainerRef}
        >
          <iframe 
            ref={iframeRef}
            src="https://rgm.games/pacman/index.html"
            title="Pacman Game" 
            className="not-found-pacman-iframe"
            allowFullScreen
            sandbox="allow-scripts allow-same-origin allow-popups"
          />
          
          <button 
            className="not-found-collapse-button"
            onClick={() => setGameExpanded(false)}
            aria-label="收起游戏"
          >
            <span>&times;</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default NotFound; 